module.exports = __webpack_public_path__ + "static/media/art.de0f772b.png";